var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dx-popup',{ref:"GestionUsuarioPopup",attrs:{"title":"Gestión Usuario","width":"1000","height":"950px","position":"top"}},[_c('GestionUsuario',{ref:"GestionUsuarioPopupCmp",attrs:{"blank":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }